import { AIIconWrapper } from '@amzn/stencil-react-components/ai';
import { IconProductAzaLarge } from '@amzn/stencil-react-icons';

/**
 * The Astra product brand mark: the Aza product glyph in the Stencil AI icon
 * wrapper (the subtle gradient treatment Stencil gives AI affordances).
 *
 * Extracted because the exact `AIIconWrapper` + `IconProductAzaLarge` pairing
 * is the Astra brand icon and was repeated across the AuditWhiz screens
 * (the Generate screen title and its generating state). One home means the mark
 * stays consistent and a future change (icon swap, size) is a single edit.
 *
 * Decorative by default: the glyph is `aria-hidden`, so place it beside a
 * visible text label (a heading or title) that carries the accessible name.
 */
export function AstraBrandIcon(): JSX.Element {
  return (
    <AIIconWrapper>
      <IconProductAzaLarge aria-hidden="true" />
    </AIIconWrapper>
  );
}
